import { APIProvider, Map } from "@vis.gl/react-google-maps";
import { GTR_MAPS_DISABLED_ID, GTR_MAPS_ID, GTR_MAPS_KEY } from "../../consts/runtimeConfig";

/**
 * GPositionsMap - Componente que renderiza o mapa
 * lib @vis.gl/react-google-maps
 * @functional-component
 */
const GPositionsMap = ({
    children,
    mapRef,
    center,
    zoom,
    tilt,
    style,
    fullscreenControl,
    gestureHandling,
    disableDefaultUI,
}: {
    children: JSX.Element;
    mapRef: React.MutableRefObject<any>;
    center: { lat: number; lng: number };
    zoom?: number;
    tilt?: number;
    style?: React.CSSProperties | undefined;
    fullscreenControl?: boolean;
    gestureHandling?: string | null;
    disableDefaultUI?: boolean | null;
}) => {
    return (
        <APIProvider apiKey={GTR_MAPS_KEY}>
            <Map
                mapId={disableDefaultUI ? GTR_MAPS_DISABLED_ID : GTR_MAPS_ID}
                onTilesLoaded={(ref) => (mapRef.current = ref.map)}
                defaultZoom={zoom ?? 15}
                defaultCenter={center}
                tilt={tilt}
                isFractionalZoomEnabled
                mapTypeId={"roadmap"}
                fullscreenControl={fullscreenControl}
                zoomControl={true}
                scaleControl={false}
                cameraControl={false}
                streetViewControl
                mapTypeControl={true}
                mapTypeControlOptions={{
                    position: 22
                }}
                streetViewControlOptions={{
                    position: 22
                }}
                headingInteractionEnabled
                rotateControl
                rotateControlOptions={{
                    position: 22
                }}
                gestureHandling={gestureHandling ?? "greedy"}
                disableDefaultUI={false}
                style={{
                    ...style,
                }}
            >
                {children}
            </Map>
        </APIProvider>
    );
};

export default GPositionsMap;
